import Vue from 'vue';
import Vuex from 'vuex';
import { setToken, getToken, removeToken } from "../utils/token";
import { login, loginOut } from "../api/userMG";

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
  state: {
    name: '',
    userId: '',
    token: getToken(),
    roleName: '',
    username: '',
    dept_id:'',
    tabname:'',
    // 是否具有汇款确认权限
    is_queren:''
  },
  getters: {
    // collapse(state) {
    //   return state.collapse
    // }
  },
  mutations: {
    SET_ROLE_NAME: (state, roleName) => {
      state.roleName = roleName
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERNAME: (state, username) =>{
      state.username=username
    },
    SET_NAME: (state, name) =>{
      state.name=name
    },
    SET_DEPT_ID:(state,dept_id)=>{
      state.dept_id=dept_id
    },
    SET_TABNAME:(state,tabname)=>{
      state.tabname=tabname
    },
    SET_IS_QUEREN:(state,is_queren)=>{
      state.is_queren=is_queren
    }
  },
  actions: {
    setDeptid({ commit }, dept_id) {
      return new Promise(((resolve, reject) => {
        if(dept_id==0){
          commit('SET_DEPT_ID', dept_id)
          localStorage.setItem('dept_id', dept_id)
          resolve(true)
        }
        if(dept_id ) {
          commit('SET_DEPT_ID', dept_id)
          localStorage.setItem('dept_id', dept_id)
          resolve(true)
        } else {
          resolve(false)
        }
      }))
    },
    setTbn({commit},tabname){
      return new Promise(((resolve,reject)=>{
        if(tabname){
          commit("SET_TABNAME",tabname)
          localStorage.setItem('tabname',tabname)
          resolve(true)
        }else{
          resolve(false)
        }
      }))
    },
    setQueRen({commit},is_queren){
      return new Promise(((resolve,reject)=>{
        if(is_queren){
          commit("SET_IS_QUEREN",is_queren)
          localStorage.setItem('is_queren',is_queren)
          resolve(true)
        }else{
          resolve(false)
        }
      }))
    },

    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          if (response.data) {

            const data = response.data
            console.log( data.user.is_queren);
            commit('SET_ROLE_NAME', data.roles.length!=0?data.roles[0].slug:'')
            commit('SET_TOKEN', data.token)
            commit('SET_IS_QUEREN', data.user.is_queren)
            commit('SET_USERNAME', data.user.username)
            commit('SET_NAME', data.user.name)
            commit('SET_USER_ID', data.user.id)
            commit('SET_DEPT_ID', data.user.dept_id)
            localStorage.setItem('token', data.token)
            localStorage.setItem('is_quren', data.user.is_queren)
            localStorage.setItem('roleName', data.roles.length!=0?data.roles[0].slug:'')
            localStorage.setItem('username', data.user.username)
            localStorage.setItem('name', data.user.name)
            localStorage.setItem('userId', data.user.id)
            localStorage.setItem('dept_id', data.user.dept_id)

          }
          console.log(response);
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        let param ={
          token:localStorage.getItem('token')
        }
        loginOut(param).then(() => {
          commit('SET_ROLE_NAME', '')
          commit('SET_TOKEN', '')
          commit('SET_IS_QUEREN', '')
          commit('SET_USERNAME', '')
          commit('SET_NAME', '')
          commit('SET_USER_ID', '')
          commit('SET_DEPT_ID', '')
          commit('SET_TABNAME','')

          localStorage.setItem('token', '')
          localStorage.setItem('is_queren','')
          localStorage.setItem('username', '')
          localStorage.setItem('name', '')
          localStorage.setItem('userId', '')
          localStorage.setItem('roleName', '')
          localStorage.setItem('dept_id', '')
          localStorage.setItem('tabname','')
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js